export default "__VITE_ASSET__Ck2w9bRB__"